import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Form, Input, Label, Button } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import withRouter from "../../../common/data/withRouter";

// import images
import bgImage from "../../../assets/images/app/bg-image.png";

class InvoiceSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    document.body.classList = "";
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
      }
    }
  };

  handleChange(event) {
    this.setState({ token: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.token.trim()) {
      this.props.router.navigate(`/public/invoice/${this.state.token.trim()}`);
    }
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="bg-half-170 bg-light d-table w-100"
          style={{ background: `url(${bgImage}) center center` }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> Search Invoice </h4>
                </div>
              </Col>
            </Row>

            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Search Invoice</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8}>
                <Card className="shadow rounded border-0">
                  <CardBody className="py-5">
                    <h4 className="card-title text-center">Track Your Invoice</h4>
                    <p className="text-muted text-center">
                      Enter your unique invoice token below to view the details.
                    </p>
                    <div className="custom-form mt-4">
                      <Form onSubmit={this.handleSubmit}>
                        <Row>
                          <Col md={12}>
                            <div className="mb-3">
                              <Label className="form-label">
                                Invoice Token <span className="text-danger">*</span>
                              </Label>
                              <div className="form-icon position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="key"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                                <Input
                                  name="token"
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Enter Token (e.g. 8f1e2d...)"
                                  value={this.state.token}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="d-grid">
                              <Button color="primary" type="submit">
                                View Invoice Details
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default withRouter(InvoiceSearch);
